import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { NgClass } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';

@Component({
    selector: 'unite-building-type-field',
    templateUrl: './building-type-field.component.html',
    styleUrls: ['./building-type-field.component.scss'],
    imports: [MatFormField, NgClass, MatSelect, ReactiveFormsModule, MatOption, TranslateModule]
})
export class BuildingTypeFieldComponent {

  control = input<FormControl>();
  classField = input('');

  editIcon = input(false);
  checkIcon = input(true);

  unit = input<boolean>(false);


  onEnter(event: KeyboardEvent) {
    (<HTMLInputElement>event.target).blur();
  }
}
